import React, { Fragment, HTMLProps } from 'react';
import InfiniteScroll from 'react-infinite-scroller';

export interface IProps extends HTMLProps<InfiniteScroll> {
  hasNextPage: boolean;
  loading: boolean;
  items: any[];
  loader?: React.ReactElement;

  loadNextPage: () => void;
  children: (props: { item: any }) => React.ReactNode;

  // className?: string,
}

export default function InfiniteLoader({
  hasNextPage,
  loading,
  items,
  children,
  loader,
  loadNextPage,
  ...attr
}: IProps) {
  const loadNextPageAfterLoading = () => {
    if (!loading && hasNextPage) {
      loadNextPage();
    }
  };

  return (
    <InfiniteScroll
      data-testid="InfiniteScroll"
      loadMore={loadNextPageAfterLoading}
      hasMore={hasNextPage}
      loader={<Fragment key="ilk">{loader}</Fragment>}
      {...attr}
    >
      {items.map((item, itemIndex) => {
        return <Fragment key={itemIndex}>{children({ item })}</Fragment>;
      })}
    </InfiniteScroll>
  );
}
